const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT || '';
const DEFAULT_STREAM_NAME = import.meta.env.VITE_KVS_STREAM_NAME || 'your-stream-name';

export interface StreamingUrlResponse {
  streamingUrl: string;
  streamName: string;
  playbackMode: string;
  startTimestamp: number | null;
  endTimestamp: number | null;
  expiresIn: number;
}

export interface KvsServiceOptions {
  streamName?: string;
  authToken?: string;
  /** Start timestamp in milliseconds for historical playback */
  startTimestamp?: number;
  /** End timestamp in milliseconds for historical playback */
  endTimestamp?: number;
}

export async function getKvsStreamingUrl(options: KvsServiceOptions = {}): Promise<StreamingUrlResponse> {
  const { streamName = DEFAULT_STREAM_NAME, authToken, startTimestamp, endTimestamp } = options;

  const queryParams = new URLSearchParams();
  if (streamName) {
    queryParams.set('streamName', streamName);
  }
  if (startTimestamp !== undefined && endTimestamp !== undefined) {
    queryParams.set('startTimestamp', startTimestamp.toString());
    queryParams.set('endTimestamp', endTimestamp.toString());
  }

  const url = `${API_BASE_URL}/v1/videos/stream-url?${queryParams.toString()}`;

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export function isHlsSupported(): boolean {
  const video = document.createElement('video');
  return !!(
    video.canPlayType('application/vnd.apple.mpegurl') ||
    (typeof window !== 'undefined' && 'Hls' in window)
  );
}
